import IconCirculeRisk from "./IconCirculeRisk.vue";
export default IconCirculeRisk